// This file will contain all constant required for project
const Constants = {
    ImportFolderPath: "/CaesarVision Files", //Provide csv files folder path from active Excel file to import data
    ExportFolderPath: "/QBO Files", //Provide folder path from active Excel file to save/export final csv file
    ImportDataSheetName: "Sales Entry Import",
    ExportDataSheetName: "Journal Entry_Output",
    LogSheetName: "Logs",
    LogSheetColumns: {
        Type: "Type", Time: "Time", Message: "Message"
    },
    // Session Storage key names 
    StorageKeys: {
        IsLogSheetExist: "EE.QBO.IsLogSheetExist",
        LogsSheetLastRow: "EE.QBO.LogsSheetLastRow",
    },
    WorkBookNames: {
        KnownStore: "knownStore",
        DateCount: "dateCount",
        JournalEntryBalance: "jeBalance",
        Class: "class",
        StartDate: "startDate"
    }
}
export default Constants;